import { Link } from "@remix-run/react";
import { cn } from "../../../lib/utils";
import { useTranslation } from "../../i18n";

interface BrandLogoProps {
	className?: string;
	size?: "sm" | "md";
}

export function BrandLogo({ className, size = "sm" }: BrandLogoProps) {
	const { localizedPath } = useTranslation();

	return (
		<Link
			to={localizedPath("/")}
			className={cn("group inline-flex min-w-0 items-center gap-2.5", className)}
			aria-label="GSplat Share"
		>
			<img
				src="/images/gsplat-share-mark.png"
				alt=""
				className={cn("shrink-0 object-contain", size === "sm" ? "h-7 w-7" : "h-8 w-8")}
			/>
			<span className="whitespace-nowrap text-base font-bold tracking-[-0.02em] text-foreground">GSplat Share</span>
		</Link>
	);
}
